import { Inject, Injectable } from '@angular/core';
import {
  FaxHistoryExtension,
  FaxHistorySearchParams,
} from '@shared/models';
import { Observable } from 'rxjs';
import { ShellService } from '@mynexus/mfe-core';
import { HttpClient } from '@angular/common/http';
import { PLATFORM_API_URL } from '@app/core/constants';


@Injectable()
export class FaxHistoryService {
  constructor(
    private shellService: ShellService,
    private http: HttpClient,
    @Inject(PLATFORM_API_URL) private readonly platformApiUrl: string,
  ) {
  }

  get getBaseUrl(){
    return this.shellService.getBaseUrlFor(this.shellService.getAppName())
  }

  getFaxHistoryListByFilters(params: FaxHistorySearchParams): Observable<FaxHistoryExtension[]> {
    return this.http.post<FaxHistoryExtension[]>(`${this.platformApiUrl}/api/FaxHistory/GetFaxHistory`, params);
  }

  resendFax(faxId: string): Observable<void> {
    return this.http.post<void>(`${this.platformApiUrl}/api/FaxHistory/ResendFax/${faxId}`, null);
  }
}
